// src/components/AssigneeAutocomplete.js
import React, { useState } from 'react';

// HINWEIS: Diese Komponente ist bereits sehr gut implementiert.
// Keine Änderungen waren notwendig.
const AssigneeAutocomplete = ({ users, teams, initialValue, onSelect, placeholder }) => {
    const [inputValue, setInputValue] = useState(initialValue || '');
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    const combinedList = [
        ...users.map(u => ({ ...u, id: u.uid, type: 'user', displayName: [u.firstName, u.lastName].filter(Boolean).join(' ') })),
        ...teams.map(t => ({ ...t, type: 'team', displayName: t.name }))
    ];

    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        if (value) {
            const filtered = combinedList.filter(item =>
                (item.displayName || '').toLowerCase().includes(value.toLowerCase())
            );
            setSuggestions(filtered);
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const handleSelect = (item) => {
        setInputValue(item.displayName);
        onSelect({ id: item.id, name: item.displayName, type: item.type });
        setShowSuggestions(false);
    };

    return (
        <div className="relative">
            <input
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                onBlur={() => setTimeout(() => setShowSuggestions(false), 150)} // Kurze Verzögerung, damit der Klick-Event ausgelöst werden kann
                onFocus={() => { if (inputValue) setShowSuggestions(true); }}
                placeholder={placeholder || "Person oder Team zuweisen"}
                className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white focus:ring-blue-500 focus:border-blue-500"
            />
            {showSuggestions && suggestions.length > 0 && (
                <ul className="absolute z-10 w-full bg-white dark:bg-gray-800 border dark:border-gray-700 rounded-lg mt-1 max-h-60 overflow-y-auto">
                    {suggestions.map(item => (
                        <li 
                            key={item.id} 
                            onMouseDown={() => handleSelect(item)} // onMouseDown wird vor onBlur ausgelöst
                            className="px-4 py-2 text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center"
                        >
                           {item.type === 'user' ? '👤' : '👥'} <span className="ml-2">{item.displayName}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default AssigneeAutocomplete;
